import { SET_AUTH0_TOKEN, SET_ADMIN_SSO_PROFILE, LOGOUT, RESET } from './actionTypes';

export const setAdminSSOProfile = adminSSOProfile => ({
	type: SET_ADMIN_SSO_PROFILE,
	adminSSOProfile,
});

export const setAuth0Token = auth0Token => ({
	type: SET_AUTH0_TOKEN,
	auth0Token,
});

export const logout = () => ({
	type: LOGOUT,
});

export const resetAuth = () => ({
	type: RESET,
});
